import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleCheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-156" data-mp="bqix9r6ncavd">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-157" data-mp="195wuxjy8o3d4">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_14px_34px_-8px_rgba(22,163,74,0.8)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-ctaDark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50" data-id="element-158" data-mp="2f3sn4jm11sez">
            <CircleCheckIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-159" data-mp="1wec8ythf61g3" />
            <span className="whitespace-nowrap" data-id="element-160" data-mp="1iejohfwhkhgk">Get It Now for Only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}